module.exports = __webpack_public_path__ + "static/media/family-tree-single-rainbow.c22546fe.svg";